namespace $.$$ {
	export class $shm_hitalama_map_widget_presets_page extends $.$shm_hitalama_map_widget_presets_page {
		
		add_pos(): readonly ( any )[] {
			return this.Map_page().get_center_pos()
		}
		
	}
}
